<template>
  <div>
    <div
      v-for="(slide, index) in getMenuFlat(
        'main',
        this.$store.state.selected_menu.pid
      )"
      :key="index"
    ></div>
    <LayoutHeadBanner
      v-if="$store.state.selected_menu"
      :itemData="$store.state.selected_menu"
    />
    <div class="container flex-box column layoutCards">
      <intersect @enter="animate = true">
        <div class="card-tabs">
          <swiper
            ref="mySwiper"
            :options="swiperOptions"
            class="card-tabs-slider fadeUp"
            :class="animate ? 'animate' : ''"
          >
            <swiper-slide
              v-for="(slide, index) in getMenuFlat(
                'main',
                this.$store.state.selected_menu.pid
              )"
              :key="slide.key"
              :class="index === 0 ? 'current' : ''"
              class="card-tab"
            >
              <router-link :to="slide.full_url">
                <div class="img-box br-12">
                  <img
                    :src="_.get(slide, 'media.optional_image.devices.desktop')"
                    alt
                    class="img-absolute br-12"
                  />
                </div>
              </router-link>
            </swiper-slide>
          </swiper>
        </div>
      </intersect>
      <Breadcrumb class="layout3" />
    </div>

    <div class="container layout-outer cards-layout flex-box">
      <div class="layout-left">
        <LayoutContent
          :itemData="$store.state.current_content"
          v-if="$store.state.current_content"
        />
        <div class="mobile-reason">
          <UsefulTools
                  :itemData="
            _.get(
              this.$store.state.current_content,
              'secondary.usefull_tools.conf'
            )
          "
                  v-if="
            _.get(
              this.$store.state.current_content,
              'secondary.usefull_tools.conf.enabled'
            ) == 1
          "
                  :bg="'noPadding whiteCol'"
                  :firstLook="2.3"
                  :ipadLook="1.5"
          />
        </div>
      </div>
      <intersect @enter="animate2 = true">
        <div class="layout-right fadeUp" :class="animate2 ? 'animate' : ''">
          <ApplicationLinkBox
            v-if="
              _.get(
                $store.state.current_content,
                'secondary.custom_banner.conf.enabled'
              ) == 1
            "
            :itemData="
              _.get(
                this.$store.state.current_content,
                'secondary.custom_banner'
              )
            "
          />
          <ProductBoxes
            v-if="
              _.get(
                this.$store.state.current_content,
                'secondary.ProductBoxes.conf.enabled'
              ) == 1
            "
            :itemData="
              _.get(this.$store.state.current_content, 'secondary.ProductBoxes')
            "
          />
        </div>
      </intersect>
    </div>

    <div class="container desktop-reason">
      <UsefulTools
              :itemData="
            _.get(
              this.$store.state.current_content,
              'secondary.usefull_tools.conf'
            )
          "
              v-if="
            _.get(
              this.$store.state.current_content,
              'secondary.usefull_tools.conf.enabled'
            ) == 1
          "
              :bg="'noPadding whiteCol'"
              :firstLook="2.3"
              :ipadLook="1.5"
      />
    </div>

    <ReasonsSlider
      v-if="
        _.get(
          this.$store.state.current_content,
          'secondary.ReasonsSlider.conf.enabled'
        ) == 1
      "
      :itemData="
        _.get(this.$store.state.current_content, 'secondary.ReasonsSlider')
      "
      :noBg="'noBg'"
    />
  </div>
</template>
<script>
import LayoutHeadBanner from "@/components/LayoutHeadBanner";
import LayoutContent from "@/components/LayoutContent";
import ApplicationLinkBox from "@/components/ApplicationLinkBox";
import ProductBoxes from "@/components/ProductBoxes";
import Breadcrumb from "@/components/Breadcrumb";
import UsefulTools from "@/components/UsefulTools";
import ReasonsSlider from "@/components/ReasonsSlider";
import mainMixin from "@/mixins/main";
import Intersect from "vue-intersect";

export default {
  components: {
    LayoutHeadBanner,
    LayoutContent,
    ApplicationLinkBox,
    ProductBoxes,
    Breadcrumb,
    UsefulTools,
    ReasonsSlider,
    Intersect,
  },
  mixins: [mainMixin],
  data() {
    return {
      animate: false,
      animate2: false,
      swiperOptions: {
        spaceBetween: 20,
        slidesPerView: "auto",
        watchOverflow: true,
      },
    };
  },

  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
    slides: function () {
      return this.tabSliderData;
    },
  },
};
</script>

<style scoped>
.container.layout3 {
  padding: 0;
  margin: initial;
}
</style>
